import axios from 'axios';
import authHeader from './auth-header';
import Jsona from "jsona";

const API_URL = process.env.VUE_APP_API_BASE_URL;

const jsona = new Jsona();

const API_PATH = `${API_URL}/backoffice/notifications`;

async function getAll(params) {
  const response = await axios.get(API_PATH, { params: params, headers: authHeader() });
  return response.data;
}

async function update(params, id) {
  const response = await axios.put(API_PATH + "/" + id, params, { headers: authHeader() });
  return jsona.deserialize(response.data);
}

async function read(id) {
  const response = await axios.put(API_PATH + "/" + id + '/set-read', {}, { headers: authHeader() });
  return jsona.deserialize(response.data);
}


async function readAll() {
  const response = await axios.put(API_PATH + "/set-read-all", {}, { headers: authHeader() });
  return jsona.deserialize(response.data);
}

async function deleteAll() {
  const response = await axios.delete(API_PATH + "/delete-all", { headers: authHeader() });
  return jsona.deserialize(response.data);
}


export default {
  getAll,
  update,
  read,
  readAll,
  deleteAll
};